export default __webpack_public_path__ + "static/google-play-0ad7901411afa4c3e7c4cd857da79b33.svg";